module.exports = __webpack_public_path__ + "img/default_map_6.c4d59458.jpg";